import React, { useCallback } from 'react';
import { useState, useEffect } from 'react';
export function splitPhoneNumber(phoneNumber) {
    if (typeof phoneNumber !== 'string') return { countryCode: '', number: '' };
    const match = phoneNumber.match(/^\+(\d{1,4})(.*)$/);
    if (match) {
        // match[1] is country code, match[2] is the rest (may have spaces)
        return {
            countryCode: '+' + match[1],
            number: match[2].replace(/^\s+/, '') // trim leading spaces
        };
    }
    return { countryCode: '', number: phoneNumber };
}

// Input Components
const OfferCodeInput = ({ index, onChange, data }) => {
    console.log("data from reply buttons ",data);
    const handleChange = (e) => {
        onChange(index, { ...data, [e.target.name]: e.target.value });
    };

    return (
        <div className="flex gap-2 w-full items-center">
            <div className="flex-1">
                <label htmlFor="buttonText" className="block text-sm font-medium text-gray-700 mb-1">
                    Button text
                </label>
                <input
                    type="text"
                    name="buttonText"
                    value={data.buttonText || data.text}
                    onChange={handleChange}
                    placeholder="Enter Button Text"
                    className=" appearance-none border text-sm rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
            </div>
            <div className="flex-1">
                <label htmlFor="offerCode" className="block text-sm font-medium text-gray-700 mb-1">
                    Offer Code
                </label>
                <input
                    type="text"
                    name="offerCode"
                    value={data.offerCode || data.offer_code}
                    onChange={handleChange}
                    placeholder="Enter the offer code"
                    className=" appearance-none text-sm border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
            </div>
        </div>
    );
};

const VisitWebsiteInput = ({ index, onChange, data }) => {
    const handleChange = (e) => {
        onChange(index, { ...data, [e.target.name]: e.target.value });
    };

    return (
        <div className="flex gap-2 w-full items-center">
            <div className="flex-1">
                <label htmlFor="buttonText" className="block text-sm font-medium text-gray-700 mb-1">
                    Button text
                </label>
                <input
                    type="text"
                    name="buttonText"
                    value={data.buttonText || data.text}
                    onChange={handleChange}
                    maxLength={25}
                    placeholder="Enter button text"
                    className=" appearance-none text-sm border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
            </div>
            <div className="flex-1">
                <label htmlFor="websiteURL" className="block text-sm font-medium text-gray-700 mb-1">
                    Website Url
                </label>
                <input
                    type="url"
                    name="websiteURL"
                    value={data.websiteURL || data.url}
                    onChange={handleChange}
                    placeholder="https://www.example.com"
                    maxLength={2000}
                    className=" appearance-none text-sm border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
            </div>
        </div>
    );
};

const CallPhoneNumberInput = ({ index, onChange, data }) => {
    
    const [countryCode, setCountryCode] = useState('');
    const [number, setNumber] = useState('');

    
    useEffect(() => {
        const fullNumber = data.phoneNumber || data.phone_number || '';
        const { countryCode: initialCC, number: initialNum } = splitPhoneNumber(fullNumber);
        
        setCountryCode(initialCC);
        setNumber(initialNum);
    }, [data.phoneNumber, data.phone_number]);

   
    const handleCountryCodeChange = (e) => {
        const newCountryCode = e.target.value;
        setCountryCode(newCountryCode); 
        
        onChange(index, { ...data, phoneNumber: `${newCountryCode}${number}`, country_code: newCountryCode });
    };

    const handleNumberChange = (e) => {
        const newNumber = e.target.value;
        setNumber(newNumber); 
       
        onChange(index, { ...data, phoneNumber: `${countryCode}${newNumber}`, number: newNumber });
    };

    return (
        <div className="flex gap-2 w-full items-center">
            <div className="flex-1">
                <label htmlFor={`buttonText-${index}`} className="block text-sm font-medium text-gray-700 mb-1">
                    Button text
                </label>
                <input
                    type="text"
                    id={`buttonText-${index}`}
                    value={data.buttonText || data.text || ''}
                    onChange={(e) => onChange(index, { ...data, buttonText: e.target.value })}
                    placeholder="Enter Button Text"
                    className=" text-sm appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
            </div>
            <div className="flex-1">
                <label htmlFor={`countryCode-${index}`} className="block text-sm font-medium text-gray-700 mb-1">
                    Country Code
                </label>
                {/* Part D: The inputs are now connected to the component's internal state. */}
                <input
                    type="text" // Changed to text to allow the '+' sign.
                    id={`countryCode-${index}`}
                    value={countryCode} // Binds to our internal state.
                    onChange={handleCountryCodeChange} // Uses our new handler.
                    placeholder="+91"
                    className="text-sm appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
            </div>
            <div className="flex-1">
                <label htmlFor={`phoneNumber-${index}`} className="block text-sm font-medium text-gray-700 mb-1">
                    Phone Number
                </label>
                <input
                    type="number"
                    id={`phoneNumber-${index}`}
                    value={number} // Binds to our internal state.
                    onChange={handleNumberChange} // Uses our new handler.
                    placeholder="Enter the Phone Number"
                    className="text-sm appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
            </div>
        </div>
    );
};
function useButtonTypes() {
    const buttonTypes = {
        copy_offer_code: OfferCodeInput,
        visit_website: VisitWebsiteInput,
        call_phone_number: CallPhoneNumberInput,
        PHONE_NUMBER: CallPhoneNumberInput,
        URL: VisitWebsiteInput,
        COPY_CODE: OfferCodeInput,

    };

    const getTypeComponent = useCallback((type) => {
        return buttonTypes[type] || null;  // Returns the component or null if not found
    }, [buttonTypes]);

    return {
        buttonTypes,
        getTypeComponent,
    };
}

export default useButtonTypes;